<script lang="ts">
	import router from "page";

	import Header from './components/Header.svelte';
	import Footer from "./components/SiteFooter.svelte";

	import Homepage from './pages/Homepage.svelte';
	import Features from './pages/Features.svelte';
	import PageNotFound from './pages/PageNotFound.svelte';
	import PricingOld from './pages/PricingOld.svelte';
	import Contact from './pages/Contact.svelte';
	import Terms from './pages/Terms.svelte';
	import Privacy from './pages/Privacy.svelte';
	import AccountConfirmation from './pages/AccountConfirmation.svelte';
	import ResetPassword from './pages/ResetPassword.svelte';

	//export let name: string;
	export let siteLinks: object;
	let page;

	// Assign pages to routes
	router('/', () => page = Homepage);
	router('/features', () => page = Features);
	router('/contact', () => page = Contact);
	router('/pricing', () => page = PricingOld);	/*
	router('/demo', () => page = Demo);
	router('/faq', () => page = FAQ);*/
	router('/terms', () => page = Terms);
	router('/privacy', () => page = Privacy); 
	router('/confirmation', () => page = AccountConfirmation);
	router('/reset-password', () => page = ResetPassword);
	router('*', () => page = PageNotFound);
	router.start();

</script>

<Header {siteLinks} />
	<div class="main-content">
		<svelte:component this={page} {siteLinks} />
	</div>
<Footer {siteLinks} />